import { SimliClient } from "simli-client";

export interface SimliCallbacks {
  onDisconnected?: () => void;
  onFailed?: (reason?: string) => void;
  onConnected?: () => void;
}

export interface SimliInitOptions {
  videoEl: HTMLVideoElement;
  audioEl: HTMLAudioElement;
  callbacks?: SimliCallbacks;
}

export interface SimliSessionData {
  session_token: string;
  ice_servers: RTCIceServer[] | null;
}

export class SimliAvatarClient {
  private client: SimliClient | null = null;
  private connected = false;

  async fetchSession(): Promise<SimliSessionData> {
    const res = await fetch("/api/simli/session", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({}),
    });
    if (!res.ok) {
      const text = await res.text();
      throw new Error(`simli session ${res.status}: ${text.slice(0, 200)}`);
    }
    return (await res.json()) as SimliSessionData;
  }

  async init(opts: SimliInitOptions): Promise<void> {
    const session = await this.fetchSession();
    const iceServers = session.ice_servers ?? null;
    const client = new SimliClient(
      session.session_token,
      opts.videoEl,
      opts.audioEl,
      iceServers,
    );
    if (opts.callbacks?.onConnected) {
      client.on("start", opts.callbacks.onConnected);
    }
    if (opts.callbacks?.onDisconnected) {
      client.on("stop", opts.callbacks.onDisconnected);
    }
    if (opts.callbacks?.onFailed) {
      client.on("error", opts.callbacks.onFailed); client.on("startup_error", opts.callbacks.onFailed);
    }
    this.client = client;
    await client.start();
    this.connected = true;
  }

  isReady(): boolean {
    return this.connected && this.client !== null;
  }

  sendAudio(pcm: Uint8Array): void {
    if (!this.client || !this.connected) return;
    this.client.sendAudioData(pcm);
  }

  clearBuffer(): void {
    if (!this.client) return;
    this.client.ClearBuffer();
  }

  async close(): Promise<void> {
    this.connected = false;
    if (!this.client) return;
    try {
      await this.client.stop();
    } catch {
      // ignore
    }
    this.client = null;
  }
}
